import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { path } from "../../../../constants";
import { useAuthContext } from "../../../../contexts/AuthContext";
import { useDefaultContext } from "../../../../contexts/UserContext";
import { LogoutSVG } from "../../../../assets/svg";
import Button from "../../../Button";
import CustomModal from "../../../CustomModal";
import profile from "../../../../assets/images/profile.png";
import "./ProfileDropdown.scss";

interface ILogoutModal {
  handleLogout: (el: boolean) => void;
}

const LogoutModal: React.FC<ILogoutModal> = ({ handleLogout }) => {
  const navigate = useNavigate();
  const { logoutUser } = useAuthContext();
  const { clearUser } = useDefaultContext();


  const handleLogoutClick = async () => {
    const response = await logoutUser();
    if (response.success) {
      clearUser();
      navigate(path.LOGIN);
    }
  };

  return (
    <div className="log-out-modal-main">
      <p className="message">
        Are you sure you want to <strong>Logout ?</strong>
      </p>
      <div className="log-out-modal-button-wrapper">
        <Button title="Cancel" className="btn-cancel" onClick={handleLogout} />
        <Button
          title="Log Out"
          className="btn-logout"
          onClick={handleLogoutClick}
        />
      </div>
    </div>
  )
} 

const ProfileDropdown = () => {
  const navigate = useNavigate();

  const { user,clearUser,isProfileLoading } = useDefaultContext();
  const [logoutModal, setLogoutModal] = useState<boolean>(false);

  const firstName = useMemo(() => {
    return user.first_name.length > 8 ? `${user.first_name.slice(0, 8)}...` : user.first_name;
  }, [user.first_name]);

  const lastName = useMemo(() => {
    return user.last_name.length > 8 ? `${user.last_name.slice(0, 8)}...` : user.last_name;
  }, [user.last_name]);

  const handleLogout = async () => {
    setLogoutModal((prev: boolean) => !prev);
  };

  const handleAdminRedirection = () => {
    const token = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");
    const redirectUrl = `${process.env.REACT_APP_CMS_BASE_URL}/login?token=${token}&refreshToken=${refreshToken}&role=${user?.role}`
    window.open(redirectUrl);
  };

  return (
    <>
      <Dropdown className="profile-dropdown">
        <Dropdown.Toggle className="d-flex profile-dropdown-btn">
          {user?.profile_assets?.thumbnail_url ? (
            <img src={user?.profile_assets?.thumbnail_url|| profile} alt="profile" className="profile-img" />
          ) : (
            <div className="profile-text">
              {`${user?.first_name?.charAt(0)?.toUpperCase()} ${user?.last_name
                ?.charAt(0)
                ?.toUpperCase()}`}
            </div>
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu className="profile-dropdown-menu">
          {
            isProfileLoading ? <div className="loader">
            <div className="spinner"></div>
          </div>:<>
          <Dropdown.Item>
            {user?.profile_assets?.thumbnail_url ? (
              <img src={user?.profile_assets?.thumbnail_url||profile} alt="profile" className="profile-img" />
            ) : (
              <div className="profile-text">
                {`${user?.first_name
                  ?.charAt(0)
                  ?.toUpperCase()} ${user?.last_name
                  ?.charAt(0)
                  ?.toUpperCase()}`}
              </div>
            )}
            <div className="intro-contain">
              <p className="profile-name">
                {firstName} {lastName}
              </p>
              <p className="profile-email">{user.email}</p>
            </div>
          </Dropdown.Item>
          <Dropdown.Item onClick={()=>{navigate(path.PERSONAL_INFO)}}>My profile</Dropdown.Item>
          {user?.isSuperAdmin && (
            <Dropdown.Item onClick={handleAdminRedirection}>
              Admin panel
            </Dropdown.Item>
          )}

          {/* <Dropdown.Item>My subscription</Dropdown.Item> */}
          <Dropdown.Item onClick={handleLogout}>
            <LogoutSVG />
            Logout
          </Dropdown.Item>
          </>
          }
        </Dropdown.Menu>
      </Dropdown>
      <CustomModal
        className="log-out-modal"
        title="Log Out"
        close={true}
        show={logoutModal}
        onHide={handleLogout}
        body={<LogoutModal handleLogout={handleLogout} />}
      />
    </>
  );
};
export default ProfileDropdown;
